import React from 'react'

import TextareaAutosize from 'react-textarea-autosize'

const ExpandableTextarea = ({ className, onFocus, placeholder, value, onChange, minRows }) => (
  <TextareaAutosize
    className={className}
    onFocus={onFocus}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    minRows={minRows}
  />
)
export default ExpandableTextarea
